import styled from "styled-components";
import TermsCheckbox from "./TermsCheckbox";

const StyledTermsCheckbox = styled(TermsCheckbox)`
  color: ${props => props.theme.COLOURS.PRIMARY.shades[80]};
`;

export default StyledTermsCheckbox;
